const Spinner = ({fill}) => (
  <div className="spinner">
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path fill={fill} d="M30.5,16 L31.5,16 C31.5,24.5601424 24.5601424,31.5 16,31.5 C7.43985763,31.5 0.5,24.5601424 0.5,16 C0.5,7.43985763 7.43985763,0.5 16,0.5 L16,1.5 C7.99214237,1.5 1.5,7.99214237 1.5,16 C1.5,24.0078576 7.99214237,30.5 16,30.5 C24.0078576,30.5 30.5,24.0078576 30.5,16 Z"></path>
    </svg>
  </div>
)

export default Spinner



// WEBPACK FOOTER //
// ./app/javascript/packs/svg/Spinner.js